import React from 'react';
import TableRow from './TableRow';

const TableBody = ({ establishments }) => {
    const rows = establishments.map(establishment => <TableRow key={establishment.id} {...establishment} />);
    return <tbody>{rows}</tbody>;
};

export default TableBody;


// WEBPACK FOOTER //
// ./src/components/Pages/Establishments/TableBody.js